import { useEffect } from 'react'

const EVENT_NAME = 'program-action-click'

const handleScroll = () => {
  const element = document.getElementById('workouts-section')

  if (element) {
    const navHeight = document.getElementById('ReactNavbar')?.scrollHeight || 80

    const top =
      element.getBoundingClientRect().top + window.pageYOffset - navHeight - 20

    window.scrollTo({ top, behavior: 'smooth' })
  }
}

export const dispatchProgramAction = (type) =>
  document.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: { type } }))

const ProgramButtonActions = ({ fetchData = () => {} }) => {
  const handleRetake = async () => {
    await fetchData()
    handleScroll()
  }

  useEffect(() => {
    const handler = (e) => {
      const actionType = e?.detail?.type
      if (!actionType) return
      switch (actionType) {
        case 'retake':
          handleRetake()
          break
        case 'stop':
          fetchData()
          break
        default:
          handleScroll()
      }
    }

    document.addEventListener(EVENT_NAME, handler)

    return () => {
      document.removeEventListener(EVENT_NAME, handler)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return null
}

export default ProgramButtonActions
